module.exports = __webpack_public_path__ + "static/media/Subscriber-Exclusive-Mobile-Banner-822x186px.0198ff6b.jpg";